import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { TranslateService } from '../../../core/services/translate.service';

@Component({
  selector: 'tt-e-commerce-status',
  templateUrl: './e-commerce-status.component.html',
  styleUrls: ['./e-commerce-status.component.css']
})
export class ECommerceStatusComponent implements OnInit {
    private translations: { [key: string]: string } = {
        ecommerce_status_update: ''
    };

    public updatingWebShop = false;

    constructor(private translateService: TranslateService, private modal: ModalService, private datatask: DataTaskService) {

    }

    private async translate() {
    	const response = await this.translateService.translateBatch(Object.keys(this.translations));

    	Object.keys(this.translations).forEach((key) => {
    		if (response[key]) {
    			this.translations[key] = response[key];
    		}
    	});
    }

    public async updateWebShop() {
        try {
            this.updatingWebShop = true;

            const response = (await this.datatask.Post(724))[0];

            if (response?.errorcode !== '0') {
                this.modal.show({
                    type: 'success',
                    title: this.translations['ecommerce_status_update'],
                    translateTitle: true,
                    message: response.statusmessage
                });
            }
        } finally {
            this.updatingWebShop = false;
        }
    }

    private async init() {
        this.translate();
    }

    ngOnInit() {
        this.init();
    }
}
